export const utils = {
	triggerFields: () => {
		const inputs = document.querySelectorAll("input");

		let isValid = true;

		// Necessário esse for separado para marcar todos os inputs inválidos, diferente do segundo for aqui eu não quero parar a execução do for quando marcar o primeiro input invalido
		for (let index = 0; index < inputs.length; index++) {
			const input = inputs[index];

			if (input.value === "" && input.required) {
				input.classList.add("is-invalid");
				input.offsetParent.lastChild.firstChild.classList.add("is-invalid");

				isValid = false;
			}
		}

		// Necessário esse segundo for pq quero parar a execução ao focar no primeiro input que está inválido.
		for (let index = 0; index < inputs.length; index++) {
			const input = inputs[index];

			if (input.value === "" && input.required) {
				input.focus();
				input.blur();

				isValid = false;
				break;
			}
		}

		return isValid;
	},
};
